import React from 'react';
import ReportShell, { formatReportTimestamp } from '../../../shared/ReportShell';
import { ProductDetailBlock } from './productReportShared';

// Read-only, print-styled summary of a single Product. Unlike Pricelist's
// report, this reads directly from the product row already loaded in the
// Products list rather than a dedicated backend endpoint: a Product has no
// nested transactional data (lines/quantity breaks) to assemble, so the
// existing list response already carries everything shown here.
function ProductReportView({ product, trackRrp, defaultTaxRate, anchorName, onClose }) {
  return (
    <ReportShell title="Product Card" subtitle={formatReportTimestamp()} onClose={onClose}>
      <ProductDetailBlock product={product} nameFontSize={16} trackRrp={trackRrp} defaultTaxRate={defaultTaxRate} anchorName={anchorName} />
    </ReportShell>
  );
}

export default ProductReportView;
